<v-menu>
  <template v-slot:activator="{ on, attrs }">
    <v-btn icon v-bind="attrs" v-on="on">
      <v-icon>mdi-dots-vertical</v-icon>
    </v-btn>
  </template>
  <v-list>
    <v-list-item @click="openBackupDialog">
      <v-list-item-title>Backup dos sistemas</v-list-item-title>
    </v-list-item>
    <v-list-item @click="openUpdateDialog">
      <v-list-item-title>Atualizar sistemas</v-list-item-title>
    </v-list-item>
    <v-list-item @click="verificarItens">
      <v-list-item-title>Verificar Itens Zabbix</v-list-item-title>
    </v-list-item>
  </v-list>
</v-menu>

<v-dialog v-model="dialogVerificarItens" max-width="900px">
  <v-card>
    <v-card-title class="headline">Verificar Itens do Zabbix</v-card-title>
    <v-card-text>
      <v-select
        v-model="itemsVerificarSistema"
        :items="['VPRA', 'VSUC', 'VSUP']"
        label="Sistema"
        outlined
        required
      ></v-select>
      
      <v-btn 
        color="primary" 
        block 
        :loading="loadingVerificarItens" 
        :disabled="!itemsVerificarSistema"
        @click="consultarItemsZabbix"
      >
        Consultar Itens
      </v-btn>
      
      <v-alert
        v-if="itemsError"
        type="error"
        class="mt-3"
      >
        {{ itemsError }}
      </v-alert>
      
      <div v-if="itemsResultado && !loadingVerificarItens" class="mt-4">
        <v-card outlined class="mb-3">
          <v-card-text class="pb-0">
            <div class="d-flex justify-space-between">
              <div>
                <strong>Host:</strong> {{ itemsResultado.hostName }}
              </div>
              <div>
                <strong>Sistema:</strong> {{ itemsResultado.sistemaNome }}
              </div>
            </div>
            <div class="d-flex justify-space-between mt-2">
              <div>
                <strong>Versão Encontrada:</strong> {{ itemsResultado.valorSelecionado || 'N/A' }}
              </div>
              <div>
                <strong>Versão Base:</strong> {{ itemsResultado.dbVersion }}
              </div>
            </div>
            <div class="mt-2">
              <strong>Método de Seleção:</strong> {{ itemsResultado.metodoSelecao }}
            </div>
            <div class="mt-2">
              <v-chip
                :color="itemsResultado.necessitaAtualizacao ? 'error' : 'success'"
                text-color="white"
              >
                {{ itemsResultado.necessitaAtualizacao ? 'ATUALIZAÇÃO NECESSÁRIA' : 'VERSÃO ATUALIZADA' }}
              </v-chip>
            </div>
          </v-card-text>
        </v-card>
        
        <div class="title mb-2">Itens Encontrados</div>
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th>Item ID</th>
                <th>Nome</th>
                <th>Chave</th>
                <th>Valor</th>
                <th>Timestamp</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in itemsResultado.items" :key="item.itemId">
                <td>{{ item.itemId }}</td>
                <td>{{ item.name }}</td>
                <td><code>{{ item.key }}</code></td>
                <td><strong>{{ item.value }}</strong></td>
                <td>{{ new Date(item.timestamp).toLocaleString() }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" text @click="dialogVerificarItens = false">
        Fechar
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

<!-- Dialog para backup dos sistemas -->
<v-dialog v-model="dialogBackup" max-width="600px">
  <v-card>
    <v-card-title class="headline">Backup dos Sistemas</v-card-title>
    <v-card-text>
      <v-select
        v-model="backupSistema"
        :items="sistemasFiltrados"
        label="Sistema"
        outlined
        required
      ></v-select>
      
      <v-btn 
        color="primary" 
        block 
        :loading="loadingBackup" 
        :disabled="!backupSistema"
        @click="realizarBackup"
      >
        Iniciar Backup
      </v-btn>
      
      <v-alert
        v-if="backupError"
        type="error"
        class="mt-3"
      >
        {{ backupError }}
      </v-alert>
      
      <v-alert
        v-if="backupSuccess"
        type="success"
        class="mt-3"
      >
        {{ backupSuccess }}
      </v-alert>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" text @click="dialogBackup = false">
        Fechar
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

<!-- Dialog para atualização dos sistemas -->
<v-dialog v-model="dialogUpdate" max-width="600px">
  <v-card>
    <v-card-title class="headline">Atualizar Sistemas</v-card-title>
    <v-card-text>
      <v-list dense rounded>
        <v-list-item
          v-for="sistema in sistemasFiltrados"
          :key="sistema"
          :class="needsUpdate(sistema) ? 'red lighten-5' : 'light-green lighten-4'"
          rounded
          class="mb-2"
        >
          <v-list-item-content>
            <v-list-item-title>
              {{ sistema }} 
              <span class="caption">
                ({{ getVersionAtual(sistema) }})
              </span>
            </v-list-item-title>
          </v-list-item-content>
          
          <v-list-item-action class="mr-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn 
                  :color="needsUpdate(sistema) ? '#970700' : 'light-green'" 
                  :loading="loadingUpdate && updateSistema === sistema" 
                  :disabled="loadingUpdate"
                  @click="needsUpdate(sistema) ? iniciarAtualizacao(sistema) : showAlreadyUpdated(sistema)"
                  v-bind="attrs"
                  v-on="on"
                  dark
                  small
                >
                  <v-icon left>{{ needsUpdate(sistema) ? 'mdi-update' : 'mdi-check' }}</v-icon>
                  {{ needsUpdate(sistema) ? 'Atualizar' : 'Atualizado' }}
                </v-btn>
              </template>
              <span v-if="!needsUpdate(sistema)">
                Sistema já está atualizado ({{ getVersionAtual(sistema) }})
              </span>
              <span v-else>
                Atualizar para a versão {{ getLatestVersion(sistema) }}
              </span>
            </v-tooltip>
            
            <!-- Novo botão para atualização sem verificação do Zabbix -->
            <v-tooltip bottom v-if="needsUpdate(sistema)">
              <template v-slot:activator="{ on, attrs }">
                <v-btn 
                  color="amber darken-2" 
                  :loading="loadingUpdateSemVerificacao && updateSistema === sistema" 
                  :disabled="loadingUpdate || loadingUpdateSemVerificacao"
                  @click="iniciarAtualizacaoSemVerificacao(sistema)"
                  v-bind="attrs"
                  v-on="on"
                  dark
                  small
                  class="ml-2"
                >
                  <v-icon left>mdi-update</v-icon>
                  Sem Verificação
                </v-btn>
              </template>
              <span>
                Atualizar sem verificar item do Zabbix (apenas executa a macro)
              </span>
            </v-tooltip>
          </v-list-item-action>
        </v-list-item>
      </v-list>
      
      <v-alert
        v-if="updateError"
        type="error"
        class="mt-3"
        dense
      >
        {{ updateError }}
      </v-alert>
      
      <v-alert
        v-if="updateSuccess"
        type="success"
        class="mt-3"
        dense
      >
        {{ updateSuccess }}
      </v-alert>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" text @click="dialogUpdate = false">
        Fechar
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

<script>
import hostsService from '@/services/hostsService';

export default {
  props: {
    host: {
      type: Object,
      required: true
    },
    systemVersions: {
      type: Object,
      default: () => ({ VPRA: null, VSUC: null, VSUP: null })
    }
  },
  data() {
    return {
      dialogVerificarItens: false,
      itemsVerificarSistema: 'VPRA',
      loadingVerificarItens: false,
      itemsResultado: null,
      itemsError: null,
      
      // Backup
      dialogBackup: false,
      backupSistema: null,
      loadingBackup: false,
      backupError: null,
      backupSuccess: null,
      
      // Update
      dialogUpdate: false,
      updateSistema: null,
      loadingUpdate: false,
      loadingUpdateSemVerificacao: false,
      updateError: null,
      updateSuccess: null,
    }
  },
  computed: {
    sistemasFiltrados() {
      const sistemas = [];
      if (this.host.hasVPRA) sistemas.push('VPRA');
      if (this.host.hasVSUC) sistemas.push('VSUC');
      if (this.host.hasVSUP) sistemas.push('VSUP');
      return sistemas;
    }
  },
  methods: {
    getVersionAtual(sistema) {
      if (!sistema) return 'N/A';
      
      const versionKey = `${sistema.toLowerCase()}Version`;
      return this.host[versionKey] || 'N/A';
    },
    
    getLatestVersion(sistema) {
      if (!sistema || !this.systemVersions) return 'N/A';
      
      return this.systemVersions[sistema] || 'N/A';
    },
    
    needsUpdate(sistema) {
      if (!sistema) return false;
      
      // Verificar se a versão atual do sistema é diferente da versão do sistema SCI
      const versionKey = `${sistema.toLowerCase()}Version`;
      const currentVersion = this.host[versionKey];
      
      // Se não temos acesso às versões mais recentes, não podemos determinar se precisa atualizar
      if (!this.systemVersions || !this.systemVersions[sistema]) {
        return true; // Assumimos que precisa atualizar para evitar bloqueio incorreto
      }
      
      const latestVersion = this.systemVersions[sistema];
      return currentVersion !== latestVersion;
    },
    
    iniciarAtualizacao(sistema) {
      this.updateSistema = sistema;
      this.realizarAtualizacao();
    },
    
    // Novo método para iniciar atualização sem verificação
    iniciarAtualizacaoSemVerificacao(sistema) {
      this.updateSistema = sistema;
      this.realizarAtualizacaoSemVerificacao();
    },
    
    showAlreadyUpdated(sistema) {
      const version = this.getVersionAtual(sistema);
      this.updateSuccess = `Sistema ${sistema} já está atualizado na versão ${version}`;
    },
    
    verificarItens() {
      this.dialogVerificarItens = true;
      this.itemsResultado = null;
      this.itemsError = null;
    },
    
    async consultarItemsZabbix() {
      if (!this.itemsVerificarSistema) {
        this.itemsError = 'Selecione um sistema primeiro';
        return;
      }
      
      this.loadingVerificarItens = true;
      this.itemsError = null;
      
      try {
        const response = await hostsService.verificarItemsZabbix(this.host.hostId, this.itemsVerificarSistema);
        
        if (response && response.success) {
          this.itemsResultado = response;
        } else {
          this.itemsError = response.message || 'Erro ao consultar itens';
        }
      } catch (error) {
        console.error('Erro ao consultar itens:', error);
        this.itemsError = error.message || 'Erro ao consultar itens';
      } finally {
        this.loadingVerificarItens = false;
      }
    },
    
    // Método para abrir o diálogo de backup
    openBackupDialog() {
      this.dialogBackup = true;
      this.backupSistema = this.sistemasFiltrados.length > 0 ? this.sistemasFiltrados[0] : null;
      this.backupError = null;
      this.backupSuccess = null;
    },
    
    // Método para realizar backup
    async realizarBackup() {
      if (!this.backupSistema) {
        this.backupError = 'Selecione um sistema primeiro';
        return;
      }
      
      this.loadingBackup = true;
      this.backupError = null;
      this.backupSuccess = null;
      
      try {
        const response = await hostsService.realizarBackup(this.host.hostId, this.backupSistema);
        
        if (response && response.success) {
          this.backupSuccess = `Backup do ${this.backupSistema} realizado com sucesso!`;
        } else {
          this.backupError = response.message || `Erro ao realizar backup do ${this.backupSistema}`;
        }
      } catch (error) {
        console.error(`Erro ao realizar backup do ${this.backupSistema}:`, error);
        this.backupError = error.message || `Erro ao realizar backup do ${this.backupSistema}`;
      } finally {
        this.loadingBackup = false;
      }
    },
    
    // Método para abrir o diálogo de atualização
    openUpdateDialog() {
      this.dialogUpdate = true;
      this.updateSistema = this.sistemasFiltrados.length > 0 ? this.sistemasFiltrados[0] : null;
      this.updateError = null;
      this.updateSuccess = null;
    },
    
    // Método para realizar atualização
    async realizarAtualizacao() {
      if (!this.updateSistema) {
        this.updateError = 'Selecione um sistema primeiro';
        return;
      }
      
      this.loadingUpdate = true;
      this.updateError = null;
      this.updateSuccess = null;
      
      try {
        const response = await hostsService.atualizarSistema(this.host.hostId, this.updateSistema);
        
        if (response && response.status === 'ALREADY_UPDATED') {
          this.updateSuccess = `Sistema ${this.updateSistema} já está atualizado para a versão ${response.newVersion}!`;
          this.loadingUpdate = false;
          return;
        }
        
        if (response && response.success) {
          // Verificação de atualização em andamento
          this.verificarProcessoAtualizacao(this.host.hostId, this.updateSistema, response.startTime);
        } else {
          this.updateError = response.message || `Erro ao atualizar ${this.updateSistema}`;
          this.loadingUpdate = false;
        }
      } catch (error) {
        console.error(`Erro ao atualizar ${this.updateSistema}:`, error);
        this.updateError = error.message || `Erro ao atualizar ${this.updateSistema}`;
        this.loadingUpdate = false;
      }
    },
    
    // Método para verificar o processo de atualização
    async verificarProcessoAtualizacao(hostId, sistema, startTime) {
      const maxTentativas = 120; // 120 tentativas × 5s = 10 minutos (alinhado com updateChecker)
      let tentativas = 0;
      const intervalo = 5000; // 5 segundos
      
      const verificarUmaVez = async () => {
        try {
          const response = await hostsService.verificarAtualizacao(hostId, sistema, startTime);
          
          if (response && response.success) {
            if (response.status === 'COMPLETED') {
              this.updateSuccess = `Atualização do ${sistema} concluída com sucesso! Nova versão: ${response.newVersion}`;
              this.loadingUpdate = false;
              return true;
            } else if (response.status === 'RUNNING') {
              // Continua verificando
              tentativas++;
              
              if (tentativas >= maxTentativas) {
                this.updateError = `Tempo limite excedido para verificar atualização do ${sistema}.`;
                this.loadingUpdate = false;
                return false;
              }
              
              setTimeout(() => verificarUmaVez(), intervalo);
              return false;
            } else {
              this.updateError = `Atualização do ${sistema} falhou: ${response.message}`;
              this.loadingUpdate = false;
              return false;
            }
          } else {
            this.updateError = response.message || `Erro ao verificar atualização do ${sistema}`;
            this.loadingUpdate = false;
            return false;
          }
        } catch (error) {
          console.error(`Erro ao verificar atualização do ${sistema}:`, error);
          
          // Incrementar tentativas mesmo com erro
          tentativas++;
          
          if (tentativas >= maxTentativas) {
            this.updateError = `Tempo limite excedido para verificar atualização do ${sistema}.`;
            this.loadingUpdate = false;
            return false;
          }
          
          setTimeout(() => verificarUmaVez(), intervalo);
          return false;
        }
      };
      
      // Iniciar a verificação
      await verificarUmaVez();
    },
    
    // Método para realizar atualização sem verificação posterior do Zabbix
    async realizarAtualizacaoSemVerificacao() {
      if (!this.updateSistema) {
        this.updateError = 'Selecione um sistema primeiro';
        return;
      }
      
      this.loadingUpdateSemVerificacao = true;
      this.updateError = null;
      this.updateSuccess = null;
      
      try {
        const response = await hostsService.atualizarSistema(this.host.hostId, this.updateSistema);
        
        if (response && response.status === 'ALREADY_UPDATED') {
          this.updateSuccess = `Sistema ${this.updateSistema} já está atualizado para a versão ${response.newVersion}!`;
          this.loadingUpdateSemVerificacao = false;
          return;
        }
        
        if (response && response.success) {
          // Sucesso na execução sem verificação posterior
          this.updateSuccess = `Macro de atualização do ${this.updateSistema} executada com sucesso! A sessão RDP permanece ativa.`;
          this.loadingUpdateSemVerificacao = false;
        } else {
          this.updateError = response.message || `Erro ao atualizar ${this.updateSistema}`;
          this.loadingUpdateSemVerificacao = false;
        }
      } catch (error) {
        console.error(`Erro ao atualizar ${this.updateSistema}:`, error);
        this.updateError = error.message || `Erro ao atualizar ${this.updateSistema}`;
        this.loadingUpdateSemVerificacao = false;
      }
    }
  }
}
</script> 